import React, { useState } from 'react';
import '../styles/CaptureMind.css';

const InputPage = () => {
  const [text, setText] = useState('');

  const handleChange = (event) => {
    setText(event.target.value);
  };

  const words = text.match(/\b\w+\b/g) || []
  //const wordCount = text.trim().split(/\s+/).filter(Boolean).length;
  const wordCount = words.length;

  return (
    <div className="input-page-container">
      <textarea
        className="input-textarea"
        value={text}
        onChange={handleChange}
        placeholder="Enter your text here..."
      />
      <div className="word-count-overlay">
        Word Count: {wordCount}
      </div>
    </div>
  );
};

export default InputPage;
